import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";
import { Announcement } from "../ManageAnnouncements";

interface AnnouncementCardProps {
  announcement: Announcement;
  onEdit: (announcement: Announcement) => void;
  onDelete: (id: number) => void;
}

export default function AnnouncementCard({
  announcement,
  onEdit,
  onDelete,
}: AnnouncementCardProps) {
  return (
    <div className="border border-border rounded-lg p-6 shadow-sm">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-display text-xl text-muted-foreground font-semibold mb-2">
            {announcement.title}
          </h3>
          <p className="text-muted-foreground mb-2">{announcement.content}</p>
          <div className="text-sm text-muted-foreground">
            Valid: {announcement.startDate} to {announcement.endDate}
          </div>
          {announcement.emailToEmployees && (
            <div className="mt-2 inline-flex items-center gap-1 rounded-full border border-success/40 bg-success/15 px-2 py-1 text-xs font-medium text-success">
              Email sent to employees
            </div>
          )}
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => onEdit(announcement)}
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="icon"
            onClick={() => onDelete(announcement.id)}
            className="text-destructive hover:text-destructive"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
